export enum UserTab {
    SEARCH_PREFERENCES,
    WATCHLIST,
    WATCHED,
    SETTINGS,
}

export const userTabsArray = ['search_preferences', 'what_watchlist', 'what_watched', 'settings'];
